/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './importContacts.defs'
export { main as default } from './importContacts.defs'
